import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ScreenType } from '../model/ScreenType';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(@Inject(DOCUMENT) private document: Document) { }

  moveComponent(component: any, containerId: string) {
    const container = this.document.getElementById(containerId);
    if (container) {
      container.innerHTML = '';

      if (component) {
        container.appendChild(component);
      }
    }
  }

  getScreenType(): ScreenType {
    const clientWidth = this.document.body.clientWidth;
    if (clientWidth <= 767) {
      return ScreenType.MOBILE;

    } else if (clientWidth <= 1023) {
      return ScreenType.TABLET;

    } else {
      return ScreenType.DESKTOP;
    }
  }

  static copy<T>(value: T): T {
    return JSON.parse(JSON.stringify(value));
  }

  public getCookieValue(key: string): string | undefined {
    try {
      const cookieMatch = document.cookie.match(new RegExp(`(?:^|; )${key}=([^;]*)`));
      return cookieMatch ? decodeURIComponent(cookieMatch[1]) : undefined;
    } catch (error) {
      console.warn('ERROR reading COOKIE:', key, error);
      return undefined;
    }
  }

  public setCookieValue(key: string, value: string, expires?: string): void {
    const expiresStr = expires ? `expires=${expires}; ` : '';
    document.cookie = `${key}=${value || ''}; ${expiresStr}path=/`;
  }

  public getLocalStorageOrCookieValue(key: string): string | undefined {
    return localStorage.getItem(key) || this.getCookieValue(key);
  }

  public linkToName(link?: string): string {
    const lastSegment = link?.split('?').shift()?.split('/').pop() || '';
    return lastSegment.replaceAll(/[_+-]/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }

  public extractDomain(url: string): string | null {
    const regex = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?([^:\/?\n]+)(?::\d+)?/;
    const match = url.match(regex);
    return match ? match[1] : '';
  }
  
  public isLogged(): boolean {
    return !!this.getCookieValue('dss');
  }

  static hasAnyValue(obj: Record<string, any> | null | undefined): boolean {
    if (!obj || typeof obj !== 'object') {
      return false;
    }

    return Object.values(obj).some(value =>
      value !== undefined &&
      value !== null &&
      value !== ''
    );
  }

  static toCamel(str: string): string {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  }

  static keysToCamel(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(v => UtilsService.keysToCamel(v));
    } else if (obj != null && obj.constructor === Object) {
      return Object.keys(obj).reduce((result, key) => {
        result[UtilsService.toCamel(key)] = UtilsService.keysToCamel(obj[key]);
        return result;
      }, {});
    }
    return obj;
  }
}
